// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1__c21e6e0739d2023f7a40","cls2":"WinBackPing-cls2___fb927173c0e018acd0a WinBackPing-cls1__c21e6e0739d2023f7a40"};